import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Container = styled.div<{ $fullWidth?: boolean }>`
  display: inline-flex;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`;

export const StyledGroupButton = styled.div<{
  size?: 'small' | 'medium' | 'large';
  width?: string;
  selected?: boolean;
  previous?: boolean;
  disabled?: boolean;
  $fullWidth?: boolean;
}>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  ${(props) => {
    switch (props.size) {
      case 'small':
        return textStyleCss(props.theme.atlas.typography.semantic.caption);
      case 'medium':
        return textStyleCss(props.theme.atlas.typography.semantic.bodySmall);
      case 'large':
        return textStyleCss(props.theme.atlas.typography.semantic.body);
      default:
        return textStyleCss(props.theme.atlas.typography.semantic.bodySmall);
    }
  }};
  border: ${({ selected, theme, disabled }) => {
    if (disabled) {
      return `1px solid ${
        selected
          ? theme.atlas.semantic.color.action.primary.disabled
          : theme.atlas.semantic.color.ui.divider.default
      }`;
    }
    return `1px solid ${
      selected
        ? theme.atlas.semantic.color.action.primary.default
        : theme.atlas.semantic.color.outline.default
    }`;
  }};
  border-left: none;
  color: ${({ selected, disabled, theme }) => {
    if (disabled) {
      return selected
        ? theme.atlas.semantic.color.action.primary.onPrimaryDisabled
        : theme.atlas.semantic.color.type.disabled;
    }
    return selected
      ? theme.atlas.semantic.color.action.primary.onPrimary
      : theme.atlas.semantic.color.type.default;
  }};
  width: ${(props) => (props.$fullWidth ? 'auto' : props.width)};
  flex: ${(props) => (props.$fullWidth ? 1 : 'none')};
  min-width: ${(props) => (props.$fullWidth ? 0 : 'auto')};
  padding: ${(props) => {
    if (props.size === 'small') {
      return '4px 12px';
    } else if (props.size === 'large') {
      return '12px 20px';
    } else {
      return '8px 16px';
    }
  }};
  height: ${(props) => {
    switch (props.size) {
      case 'small':
        return '28px;';
      case 'medium':
        return '40px;';
      case 'large':
        return '56px;';
    }
  }};
  background-color: ${({ selected, theme, disabled }) => {
    if (selected) {
      return disabled
        ? theme.atlas.semantic.color.action.primary.disabled
        : theme.atlas.semantic.color.action.primary.default;
    }
    return theme.atlas.semantic.color.surface.default;
  }};
  @media (hover: hover) {
    &:hover {
      cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
      background-color: ${({ selected, theme, disabled }) => {
        if (disabled) {
          return selected
            ? theme.atlas.semantic.color.action.primary.disabled
            : theme.atlas.semantic.color.surface.default;
        }
        return selected
          ? theme.atlas.semantic.color.action.primary.hover
          : theme.atlas.semantic.color.action.secondary.hoverFill;
      }};
    }
  }

  &:active {
    background-color: ${({ theme, disabled, selected }) => {
      if (disabled) {
        return selected
          ? theme.atlas.semantic.color.action.primary.disabled
          : theme.atlas.semantic.color.surface.default;
      }
      return selected
        ? theme.atlas.semantic.color.action.primary.active
        : theme.atlas.semantic.color.action.secondary.activeFill;
    }};
  }

  &:first-child {
    border-radius: 3px 0 0 3px;
    border-left: ${({ selected, theme, disabled }) => {
      if (disabled) {
        return `1px solid ${
          selected
            ? theme.atlas.semantic.color.action.primary.disabled
            : theme.atlas.semantic.color.ui.divider.default
        }`;
      }
      return selected
        ? `1px solid ${theme.atlas.semantic.color.action.primary.default}`
        : `1px solid ${theme.atlas.semantic.color.outline.default}`;
    }};
  }
  &:last-child {
    border-radius: 0 3px 3px 0;
  }
  ${({ previous, theme, disabled }) => {
    if (disabled)
      return (
        previous &&
        `border-right: 1px solid ${theme.atlas.semantic.color.ui.divider.default}`
      );
    return (
      previous &&
      `border-right: 1px solid ${theme.atlas.semantic.color.action.primary.default}`
    );
  }}
`;

export const Input = styled.input`
  appearance: none;
  position: fixed;
`;

export const Label = styled.label<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
